import VTooltip from 'v-tooltip'
import Vue from 'vue'

Vue.use(VTooltip)
